import { render, staticRenderFns } from "./WarnApiTokenConnectionProviderTooltip.vue?vue&type=template&id=4ba31579&scoped=true&"
import script from "./WarnApiTokenConnectionProviderTooltip.vue?vue&type=script&lang=ts&"
export * from "./WarnApiTokenConnectionProviderTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./WarnApiTokenConnectionProviderTooltip.vue?vue&type=style&index=0&id=4ba31579&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba31579",
  null
  
)

export default component.exports